import Alert from './Alert';

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Common/Alert/index.js